import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { List, ListItem } from '@material-ui/core';
import { AppTheme } from '../../styles/AppTheme';

export class SortByDialog extends Component {
  getDefaultSortOptions = () => [
    { key: 'createdTs', label: 'Created Date' },
    { key: 'modifiedTs', label: 'Modified Date' },
    { key: 'activeIntSentTs', label:'Last Activity Date'}
  ]

  getSortOptions = () => {
    return this.props.sortOptions || this.getDefaultSortOptions()
  }

  getCurrentSortKey = () => {
    return (this.props.searchFilters || {})._sortKey || 'createdTs'
  }

  handleSortSelect = (sortKey) => {
    if (this.props.onSortKeyChange) {
      this.props.onSortKeyChange(sortKey)
    }
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const currentSortKey = this.getCurrentSortKey()
    const sortOptions = this.getSortOptions()

    return (
      <div className={css(Styles.sortDialogContainer)}>
        <List>
          {sortOptions.map((option, index) => (
            <ListItem
              key={index}
              button
              onClick={() => this.handleSortSelect(option.key)}
              className={css(
                Styles.sortDialogItem,
                currentSortKey === option.key && Styles.selectedItem
              )}
            >
              <p className={css(Styles.sortDialogText, currentSortKey === option.key && Styles.selectedItemText)}>{option.label}</p>
            </ListItem>
          ))}
        </List>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  sortDialogContainer: {
    padding: '16px',
  },
  sortDialogItem: {
    backgroundColor: '#ffffff',
    margin: '4px 0',
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ':hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  sortDialogText: {
    color: AppTheme.primaryColor,
    fontSize: 16,
    fontWeight: 500,
    textDecoration: 'none',
    textAlign: 'left',
    wordBreak: 'break-word',
    margin: 0,
  },
  selectedItem: {
    backgroundColor: AppTheme.primaryColor,
    ':hover': {
      backgroundColor: AppTheme.primaryColor,
    },
  },
  selectedItemText: {
    color: '#ffffff',
  },
});